var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('v-alert',{attrs:{"type":"error","icon":"mdi-alert-circle"}},[_vm._v(" "+_vm._s(_vm.messages[_vm.text])+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }